<template>
  <div class="types-of-practice">
    <div
      v-for="(item, index) in practiceList"
      :key="index"
      class="practice-item"
      @click="choosePractice(item)"
    >
      <div class="practice-item-text">{{ item.text }}</div>

      <img src="@/assets/images/free-practice/yellow__next_arrow.png" class="next-arrow" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      practiceList: [
        {
          text: this.$t('word_flashcards'),
          key: 'FLASHCARDS',
        },
        {
          text: this.$t('word_practice'),
          key: 'EXERCISE',
        },
        {
          text: this.$t('analyse_text'),
          key: 'ANALYSE',
        },
      ],
    }
  },
  methods: {
    choosePractice(item) {
      this.$emit('choosePractice', item.key)
    },
  },
}
</script>
<style lang="scss" scoped>
.types-of-practice {
  display: flex;
  justify-content: center;
  margin-top: 34px;
  margin-bottom: 15px;
  .practice-item {
    background: #515571;
    min-height: 115px;
    width: 185px;
    padding: 17px 20px 45px;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 30px;
    position: relative;
    transition: all 80ms cubic-bezier(0, 0, 0.2, 1);
    overflow: hidden;
    .practice-item-text {
      font-size: 20px;
      line-height: 24px;
      color: #fff;
      width: 120px;
      word-break: break-word;
    }
    .next-arrow {
      position: absolute;
      bottom: 10px;
      left: 20px;
      width: 24px;
      height: 24px;
    }
  }
  .practice-item:hover {
    box-shadow: 0 0.5em 0.5em -0.4em #515571;
    transform: translate(0, -2px);
  }
  .practice-item::before {
    content: '';
    background-image: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.15));
    width: 200%;
    height: 200%;
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    transform: translateX(-100%) translateY(-100%) rotate(30deg);
  }
  .practice-item:hover::before {
    transition: all 1s;
    transform: translateX(100%) translateY(100%) rotate(30deg);
  }
}
</style>
